import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import './i18n';
import AntdLocale from './i18n/AntdLocale';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';
import { installGlobalErrorReporting } from './utils/reportError';

installGlobalErrorReporting();

// 界面语言见 src/i18n（docs/I18N.md）：antd / dayjs 的内置文字随界面语言切换（AntdLocale、i18n 的 languageChanged），
// 不再跟随浏览器语言——否则界面是中文时，非中文浏览器下日期面板、分页等变英文，与页面中文混搭。

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AntdLocale>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AntdLocale>
    </QueryClientProvider>
  </React.StrictMode>
);
